import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetHelpComponent } from './get-help';
import { FormsModule } from '@angular/forms';
import { MsgBoxComponent, MsgBoxPopupComponent } from './msg-box';
import { MatDialogModule } from '@angular/material/dialog';
import { ComboboxComponent } from './combo-box';
import { CheckBoxModule, ButtonModule } from '@syncfusion/ej2-angular-buttons';
import { NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { MultiSelectAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { MultiSelectDropdownComponent } from './multi-select-dropdown/multi-select-dropdown.component';
import { MultiSelectValidator } from './multi-select-validator';
import { CommonSubscriberComponent } from './common-tokbox/common-subscriber/common-subscriber.component';
import { ApportisCalendarComponent } from './calendar/apportis.calendar.component';
import { ClinicianPopupComponent } from './clinician-popup/clinician-popup.component';
import { TelPipe } from './pipes/tel.pipe';
import { TranslateOrgSpecificPipe } from './pipes/translate-org-specific.pipe';
import { TranslateSignInPipe } from './pipes/translate-sign-in.pipe';
import { OptionControlComponent } from './option-control/option-control.component';
import { ResourceSearchfilterPipe } from './pipes/resource-searchfilter.pipe';
import { FoodShelterSearchfilterPipe } from './pipes/foodshelterfilter.pipe';
import { RouterModule } from '@angular/router';
import { PatientCaseComponent } from './patient-case/patient-case.component';
import { AppointmentService } from '../appointment/appointment.service';
import { NewCaseComponent } from './new-case/new-case.component';
import { CasemanagerCasePopupComponent } from './casemanager-case-popup/casemanager-case-popup.component';
import { CaseSearchfilterPipe } from './pipes/case-searchfilter.pipe';
import { ClientListPopupComponent } from './client-list-popup/client-list-popup.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { AddNotePopupComponent } from './add-note-popup/add-note-popup.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ParticipantProfileViewComponent } from './participant-profile-view/participant-profile-view.component';
import { AppointmentCompletionComponent } from '../appointment/appointment-completion/appointment.comple.component';
import { ConfirmBoxComponent } from './confirm-box/confirm-box.component';
import { CountyEmergencyInfoSearchfilterPipe } from './pipes/county-emergency-info-searchfilter.pipe';
import { FoodAndShelterAdminSearchfilterPipe } from './pipes/food-and-shelter-admin-searchfilter.pipe';
import { CovidTrackingSearchfilterPipe } from './pipes/covid-tracking-searchfilter.pipe';
import { CovidTrackingOrglistSearchfilterPipe } from './pipes/covid-tracking-orglist-searchfilter.pipe';
import { BulkUploadSearchfilterPipe } from './pipes/bulk-upload-searchfilter.pipe';
import { OrganizationSearchfilterPipe } from './pipes/organization-searchfilter.pipe';
import { RichtextboxEditorComponent } from './richtextbox-editor/richtextbox-editor.component';
import { EditorModule } from '@tinymce/tinymce-angular';
import { ReferalSearchPipe } from './pipes/referal-search.pipe';
import { AssignReferralComponent } from '../referrals/assign-referral/assign-referral.component';

@NgModule({
    declarations: [
        GetHelpComponent,
        MsgBoxComponent,
        MsgBoxPopupComponent,
        ComboboxComponent,
        MultiSelectDropdownComponent,
        MultiSelectValidator,
        CommonSubscriberComponent,
        ApportisCalendarComponent,
        ClinicianPopupComponent,
        TelPipe,
        TranslateOrgSpecificPipe,
        TranslateSignInPipe,
        OptionControlComponent,
        ResourceSearchfilterPipe,
        FoodShelterSearchfilterPipe,
        ReferalSearchPipe,
        PatientCaseComponent,
        NewCaseComponent,
        CasemanagerCasePopupComponent,
        CaseSearchfilterPipe,
        ClientListPopupComponent,
        AddNotePopupComponent,
        ParticipantProfileViewComponent,
        AppointmentCompletionComponent,
        ConfirmBoxComponent,
        CountyEmergencyInfoSearchfilterPipe,
        FoodAndShelterAdminSearchfilterPipe,
        CovidTrackingSearchfilterPipe,
        CovidTrackingOrglistSearchfilterPipe,
        BulkUploadSearchfilterPipe,
        OrganizationSearchfilterPipe,
        RichtextboxEditorComponent,
        AssignReferralComponent
    ],
    imports: [
        EditorModule,
        CommonModule,
        FormsModule,
        MatDialogModule,
        MultiSelectAllModule,
        ButtonModule,
        CheckBoxModule,
        NumericTextBoxModule,
        DropDownListModule,
        Ng2SearchPipeModule,
        NgbModule,
        RouterModule,
    ],
    entryComponents: [AppointmentCompletionComponent, MsgBoxPopupComponent, ClinicianPopupComponent, PatientCaseComponent, NewCaseComponent, CasemanagerCasePopupComponent, ClientListPopupComponent, AddNotePopupComponent, ConfirmBoxComponent],
    exports: [
        GetHelpComponent,
        MsgBoxComponent,
        ComboboxComponent,
        MultiSelectDropdownComponent,
        MultiSelectValidator,
        DropDownListModule,
        CommonSubscriberComponent,
        ApportisCalendarComponent,
        TelPipe,
        TranslateOrgSpecificPipe,
        TranslateSignInPipe,
        OptionControlComponent,
        ResourceSearchfilterPipe,
        CaseSearchfilterPipe,
        FoodShelterSearchfilterPipe,
        ReferalSearchPipe,
        ParticipantProfileViewComponent,
        CountyEmergencyInfoSearchfilterPipe,
        FoodAndShelterAdminSearchfilterPipe,
        CovidTrackingSearchfilterPipe,
        CovidTrackingOrglistSearchfilterPipe,
        BulkUploadSearchfilterPipe,
        RichtextboxEditorComponent,
        OrganizationSearchfilterPipe
    ],
    providers: [TelPipe,
        TranslateOrgSpecificPipe,
        AppointmentService,AssignReferralComponent],
})
export class ApportisCommonModule { }
